import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { EvaluationDetailsHandler } from './evaluation-details.handler';
import { Location } from '@angular/common';

@Component({
  selector: 'sym-evaluation-details',
  templateUrl: './evaluation-details.component.html',
  styleUrls: ['./evaluation-details.component.scss'],
})
export class EvaluationDetailsComponent extends EvaluationDetailsHandler implements OnInit {
  constructor(
    service: ContestAndIncentiveDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  async ngOnInit() {
    this.evaluationId = this.route.snapshot.paramMap.get('id');
    await this.getCompanyFacet();
    super.ngOnInit();
  }

  async getCompanyFacet() {
    await this.loadData(this.evaluationId);
  }
}
